import { Swiper } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "./swiperflow.css";


export default function SwiperFlow({children, extraRightPadding = 10}) {
  return (
    <Swiper spaceBetween={10} slidesPerView={`auto`} className={`swiper-flow-main-wrapper`} style={{"--extra-swiper-padding-right": `${extraRightPadding}px`}}>
        {children}
    </Swiper>
  )
}
